module.exports = "data:image/png;base64,UklGRjgBAABXRUJQVlA4TCsBAAAvE8AEEL/BqI0kR94MaHkcfxz3y02DQdtIjjx3Xyk8qOfPpQ2jSJIiZWOAN/7loQD2aLaRbSv5uDsRKf3TjUsHRK7334A47h2sveTgxCnPG/75zqpl+kMTiiiKlFLKEmkEJUiLlISlFJjkDLmUBTPkSimYCAMFKUopwotopVR4Iaa/MGAVXmUFj7CE1FYlhj+WmlGPYa5b12uZ1zp/7mvdcBjZttI8iLsTDxq/uPXf2pfHLyGi/4zcto1En7rPJL8gJYO5cz0vRw0xGV6g5rfQTV9gklaKNfg8a6H8dsCRqHXRJS5oBtbpAyCiHWtrBQCS3o2zse+QGb8Zjv2AYiX9JyGQ1S40yiDvh/vah2asbsmbxoMm6WkXHbjyRGa1MqqpWe2NemTcS6OeEwA="


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/tick.png
// module id = ../../../../../src/assets/images/tick.png
// module chunks = main